 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTRUTH_COVER from '@/components/Text/RUTH_cover'
 import TEXTRUTH_TITLEPAGE from '@/components/Text/RUTH_titlepage'
 import TEXTRUTH_IMPRINT from '@/components/Text/RUTH_imprint'
 import TEXTRUTH_DEDICATION from '@/components/Text/RUTH_dedication'
 import TEXTRUTH_CONTENTS from '@/components/Text/RUTH_contents'
 import TEXTRUTH_GENPREF from '@/components/Text/RUTH_genpref'
 import TEXTRUTH_AUTPREF from '@/components/Text/RUTH_autpref'
 import TEXTRUTH_ABBREV from '@/components/Text/RUTH_abbrev'
 import TEXTRUTH_INTRO from '@/components/Text/RUTH_intro'
 import TEXTRUTH_PT1 from '@/components/Text/RUTH_pt1'
 import TEXTRUTH_CH01 from '@/components/Text/RUTH_ch01'
 import TEXTRUTH_CH02 from '@/components/Text/RUTH_ch02'
 import TEXTRUTH_PT2 from '@/components/Text/RUTH_pt2'
 import TEXTRUTH_CH03 from '@/components/Text/RUTH_ch03'
 import TEXTRUTH_CH04 from '@/components/Text/RUTH_ch04'
 import TEXTRUTH_PT3 from '@/components/Text/RUTH_pt3'
 import TEXTRUTH_CH05 from '@/components/Text/RUTH_ch05'
 import TEXTRUTH_CH06 from '@/components/Text/RUTH_ch06'
 import TEXTRUTH_PT4 from '@/components/Text/RUTH_pt4'
 import TEXTRUTH_CH07 from '@/components/Text/RUTH_ch07'
 import TEXTRUTH_CH08 from '@/components/Text/RUTH_ch08'
 import TEXTRUTH_CH09 from '@/components/Text/RUTH_ch09'
 import TEXTRUTH_NOTES from '@/components/Text/RUTH_notes'
 import TEXTRUTH_OT from '@/components/Text/RUTH_OT'
 import TEXTRUTH_NT from '@/components/Text/RUTH_NT'
 import TEXTNAV from '@/components/Text/nav'
 import TEXTAUTHOR from '@/components/Text/author'
 import TEXTMOREIVP from '@/components/Text/moreIVP'
 import TEXTIVPTBS from '@/components/Text/IVPtbs'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/RUTH_contents",
 			"name" : "Text/RUTH_contents",
 			"component" : TEXTRUTH_CONTENTS
 		},
 		{
 			"path" : "/Text/RUTH_genpref",
 			"name" : "Text/RUTH_genpref",
 			"component" : TEXTRUTH_GENPREF
 		},
 		{
 			"path" : "/Text/RUTH_autpref",
 			"name" : "Text/RUTH_autpref",
 			"component" : TEXTRUTH_AUTPREF
 		},
 		{
 			"path" : "/Text/RUTH_abbrev",
 			"name" : "Text/RUTH_abbrev",
 			"component" : TEXTRUTH_ABBREV
 		},
 		{
 			"path" : "/Text/RUTH_intro",
 			"name" : "Text/RUTH_intro",
 			"component" : TEXTRUTH_INTRO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js